(ns manatee.session.subs
  (:require [manatee.session.app-db :as session-db]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::activity
 (fn activity
   [db _]
   (session-db/get-activity db)))

(rf/reg-sub
 ::session
 (fn session
   [db _]
   (session-db/get-session db)))
